export default __webpack_public_path__ + "static/media/p06 p03.915d876f.jpg";